import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")

  return (_openBlock(), _createBlock("div", {
    class: _ctx.getVisibility()
  }, [
    _createVNode(_component_ProgressSpinner, { baseZIndex: 9999 })
  ], 2))
}